import { destinationError, hubError, partnerError } from '../../constants/errors';
var validation = function (values) {
    var errors = {};
    if (!(values === null || values === void 0 ? void 0 : values.hubId)) {
        errors.hubId = hubError;
    }
    if (!(values === null || values === void 0 ? void 0 : values.partnerDestinationId)) {
        errors.partnerDestinationId = destinationError;
    }
    if (!(values === null || values === void 0 ? void 0 : values.partner)) {
        errors.partner = partnerError;
    }
    return errors;
};
export default validation;
//# sourceMappingURL=createConsolidation.js.map